import styled from 'styled-components';

const FooterGroup = styled.div `
  border-top: 1px solid ${props => props.theme.colors.background.tertiary};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 24px 32px;
`;
const StyledFooter = styled.div `
  display: flex;
  justify-content: flex-end;
`;

export { FooterGroup, StyledFooter };
